import { Component, OnInit, Input } from '@angular/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';

@Component({
  selector: 'app-employee-system',
  templateUrl: './employee-system.component.html',
  styleUrls: ['./employee-system.component.scss']
})
export class EmployeeSystemComponent implements OnInit {
  permission:{}={}
  holiday:{}={}
  DelayRuleList:{}[]=[]
  AbsenceRuleList:{}[]=[]
  ExtraTimeRuleList:{}[]=[]
  employeeAfairsdropdown:{}[]=[]
  insurancedropdown:{}[]=[]
  taxesdropdown:{}[]=[]

  @Input() form:any = {}
  constructor( public gt: genericCustomStoreService) {
    this.gt.getdropdowndata("PermissionHeaderWorkSystem").subscribe((res:[])=>this.permission=res)
    this.gt.getdropdowndata("HolidayHeaderSystem").subscribe((res:[])=>this.holiday=res)
    this.gt.getdropdowndata("DelayRuleHeaderSystem").subscribe((res:[])=>this.DelayRuleList=res)
    this.gt.getdropdowndata("AbsenceRuleHeaderSystem").subscribe((res:[])=>this.AbsenceRuleList=res)
    this.gt.getdropdowndata("ExtraTimeRuleHeaderSystem").subscribe((res:[])=>this.ExtraTimeRuleList=res)
    this.gt.getdropdowndata("EmployeeAfairsSetting").subscribe((res:[])=>this.employeeAfairsdropdown=res)
    this.gt.getdropdowndata("InsuranceSetting").subscribe((res:[])=>this.insurancedropdown=res)
    this.gt.getdropdowndata("TaxScheduleSetting").subscribe((res:[])=>this.taxesdropdown=res)
    }

  ngOnInit(): void {}

}
